import actions from './actions';

const {
  CREATE_VIDEOSOURCE_BEGIN,
  CREATE_VIDEOSOURCE,
  CREATE_VIDEOSOURCE_ERR,
  CREATE_VIDEOSOURCE_EMPTY,
  FETCH_ALL_VIDEOSOURCE_LIST_BEGIN,
  FETCH_ALL_VIDEOSOURCE_LIST,
  FETCH_ALL_VIDEOSOURCE_LIST_ERR,
  FETCH_VIDEOSOURCE_DETAILS_BEGIN,
  FETCH_VIDEOSOURCE_DETAILS,
  FETCH_VIDEOSOURCE_DETAILS_ERR,

  UPDATE_VIDEOSOURCE_DETAILS_BEGIN,
  UPDATE_VIDEOSOURCE_DETAILS,
  UPDATE_VIDEOSOURCE_DETAILS_ERR,
  UPDATE_VIDEOSOURCE_DETAILS_EMPTY,
} = actions;

const initialStateFilter = {
  data: [],
  loading: false,
  error: null,
};
const VideoSourceReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_VIDEOSOURCE_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case CREATE_VIDEOSOURCE:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case CREATE_VIDEOSOURCE_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    case CREATE_VIDEOSOURCE_EMPTY:
      return {
        ...initialStateFilter,
        loading: false,
      };
    default:
      return state;
  }
};

const VideoSourceListReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  console.log('action in reducer', data);
  switch (type) {
    case FETCH_ALL_VIDEOSOURCE_LIST_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_ALL_VIDEOSOURCE_LIST:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_ALL_VIDEOSOURCE_LIST_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const VideoSourceDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_VIDEOSOURCE_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_VIDEOSOURCE_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_VIDEOSOURCE_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const UpdateVideoSourceDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case UPDATE_VIDEOSOURCE_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case UPDATE_VIDEOSOURCE_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case UPDATE_VIDEOSOURCE_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    case UPDATE_VIDEOSOURCE_DETAILS_EMPTY:
      return {
        ...initialStateFilter,
        loading: true,
      };
    default:
      return state;
  }
};
export { VideoSourceReducer, VideoSourceListReducer, VideoSourceDetailsReducer, UpdateVideoSourceDetailsReducer };
